import { useState, useCallback } from 'react';
import api from '../api/api';

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /** Stable reference so effects that list `[request]` do not re-run every render. */
  const request = useCallback(async ({ method, url, data = null, params = {}, withAuth = false }) => {
    setLoading(true);
    setError(null);

    try {
      const headers = {};
      if (withAuth) {
        const token = localStorage.getItem('access_token');
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
      }
      const response = await api({
        method,
        url,
        data,
        params,
        headers
      });
      return response.data;
    } catch (err) {
      setError(err);
      console.error("API Error:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  /** POST multipart/form-data (e.g. image uploads). Do not set Content-Type manually — browser sets boundary. */
  const postMultipart = useCallback(async ({ url, formData, withAuth = true }) => {
    setLoading(true);
    setError(null);
    try {
      const headers = {};
      if (withAuth) {
        const token = localStorage.getItem('access_token');
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
      }
      const response = await api({
        method: 'post',
        url,
        data: formData,
        headers,
      });
      return response.data;
    } catch (err) {
      setError(err);
      console.error('API Error:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { request, postMultipart, loading, error };
};

export default useApi;
